webpackJsonp([2],{

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_pillars_vue__ = __webpack_require__(542);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebc0736_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_pillars_vue__ = __webpack_require__(597);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ebc0736"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_pillars_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebc0736_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_pillars_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pillars_section_pillars__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pillars_slider_pillars__ = __webpack_require__(593);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function data() {
	return {
		windowSize: {
			x: 0,
			y: 0
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-pillars',
	data: data,
	components: {
		sectionPillars: __WEBPACK_IMPORTED_MODULE_0__components_pillars_section_pillars__["a" /* default */],
		sliderPillars: __WEBPACK_IMPORTED_MODULE_1__components_pillars_slider_pillars__["a" /* default */]
	},
	methods: {
		onResize: onResize
	}
});

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-pillars',
	props: {
		windowSize: {
			type: Object,
			default: function _default() {}
		}
	}
});

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_css_swiper_css__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function data() {
	return {
		imgsPillars: [{
			id: 1,
			backgroundImage: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/image-pillars-1.png',
			title: 'CONOCIMIENTO',
			title42: 'DEL NEGOCIO',
			content: 'Si no conocemos el negocio no podemos tener éxito en esto, somos curiosos, apasionados por lo que hacemos.Queremos usar tecnología para impactar los negocios del mundo y simplificarle la vida a los soñadores(empresarios) como nosotros. ',
			number: 1
		}, {
			id: 2,
			title: 'DESARROLLO',
			title42: 'TECNOLÓGICO',
			backgroundImage: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/image-billars-2.png',
			content: 'Estamos un paso adelante en cuanto a tecnología se trata, no queremos estar en nuestra zona de confort, nosotros vamos por más.',
			number: 2
		}, {
			id: 3,
			title: 'DESARROLLO',
			title42: 'COMERCIAL',
			backgroundImage: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/image-billars-3.png',
			content: 'Somos disruptivos, estamos acostumbrados a romper los paradignas, a pensar diferente e ir por el atajo en lugar del camino frecuente, nos distingue nuestra nueva forma de pensar, la misma que usamos para crear productos exitosos',
			number: 3
		}],
		swiperOption: {
			spaceBetween: 0,
			centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'slider-pillars',
	data: data,
	components: {
		swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"],
		swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"]
	}
});

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("7b652888", content, true);

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".background-gray[data-v-1ebc0736]{background-color:#f2f2f2;height:11px;width:100%}.content-pillars[data-v-1ebc0736]{display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:1024px){.content-pillars[data-v-1ebc0736]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.slider-pillars[data-v-1ebc0736]{width:50%}@media (max-width:1024px){.slider-pillars[data-v-1ebc0736]{width:100%}}.content-section[data-v-1ebc0736]{width:50%}@media (max-width:1024px){.content-section[data-v-1ebc0736]{width:100%}}", "", {"version":3,"sources":["/opt/build/repo/src/pages/page-pillars.vue"],"names":[],"mappings":"AACA,kCACE,yBAA0B,AAC1B,YAAa,AACb,UAAY,CACb,AACD,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,0BACA,kCACM,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACpC,CACA,AACD,iCACE,SAAW,CACZ,AACD,0BACA,iCACM,UAAY,CACjB,CACA,AACD,kCACE,SAAW,CACZ,AACD,0BACA,kCACM,UAAY,CACjB,CACA","file":"page-pillars.vue","sourcesContent":["\n.background-gray[data-v-1ebc0736] {\n  background-color: #f2f2f2;\n  height: 11px;\n  width: 100%;\n}\n.content-pillars[data-v-1ebc0736] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n@media (max-width: 1024px) {\n.content-pillars[data-v-1ebc0736] {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n}\n.slider-pillars[data-v-1ebc0736] {\n  width: 50%;\n}\n@media (max-width: 1024px) {\n.slider-pillars[data-v-1ebc0736] {\n      width: 100%;\n}\n}\n.content-section[data-v-1ebc0736] {\n  width: 50%;\n}\n@media (max-width: 1024px) {\n.content-section[data-v-1ebc0736] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_pillars_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6449a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_pillars_vue__ = __webpack_require__(592);
function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a6449a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_pillars_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6449a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_pillars_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("0bc56336", content, true);

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".section-pillars[data-v-2a6449a4]{background-color:#fff;padding-top:140px;width:100%}@media (max-width:1024px){.section-pillars[data-v-2a6449a4]{padding:59px 37px}}.grid-arrow[data-v-2a6449a4]{display:-webkit-box;display:-ms-flexbox;display:flex}.text-description[data-v-2a6449a4]{color:#4a4a4a;font-family:Lato,sans-serif;font-weight:400;font-size:24px}@media (max-width:1024px){.text-description[data-v-2a6449a4]{font-size:18px}}.number-pillars[data-v-2a6449a4]{color:#05316a;font-size:30px;font-family:Lato,sans-serif;font-weight:900}@media (max-width:1024px){.number-pillars[data-v-2a6449a4]{font-size:24px}}.title-section-pillars[data-v-2a6449a4]{color:#3bb4c1;font-family:Lato,sans-serif;font-weight:900;font-size:24px;line-height:1.67;margin-bottom:30px}@media (max-width:1024px){.title-section-pillars[data-v-2a6449a4]{font-size:18px}}.content-text-pillars[data-v-2a6449a4]{margin:90px auto;max-width:455px}@media (max-width:1024px){.content-text-pillars[data-v-2a6449a4]{margin:25px auto}}@media (max-width:1024px){.icons-arrow[data-v-2a6449a4]{width:282px}}.icon-logo-responsive[data-v-2a6449a4]{margin-bottom:60px}", "", {"version":3,"sources":["/opt/build/repo/src/components/pillars/section-pillars.vue"],"names":[],"mappings":"AACA,kCACE,sBAA0B,AAC1B,kBAAmB,AACnB,UAAY,CACb,AACD,0BACA,kCACM,iBAAmB,CACxB,CACA,AACD,6BACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,mCACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,cAAgB,CACjB,AACD,0BACA,mCACM,cAAgB,CACrB,CACA,AACD,iCACE,cAAe,AACf,eAAgB,AAChB,4BAAgC,AAChC,eAAiB,CAClB,AACD,0BACA,iCACM,cAAgB,CACrB,CACA,AACD,wCACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,0BACA,wCACM,cAAgB,CACrB,CACA,AACD,uCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,0BACA,uCACM,gBAAkB,CACvB,CACA,AACD,0BACA,8BACI,WAAa,CAChB,CACA,AACD,uCACE,kBAAoB,CACrB","file":"section-pillars.vue","sourcesContent":["\n.section-pillars[data-v-2a6449a4] {\n  background-color: #ffffff;\n  padding-top: 140px;\n  width: 100%;\n}\n@media (max-width: 1024px) {\n.section-pillars[data-v-2a6449a4] {\n      padding: 59px 37px;\n}\n}\n.grid-arrow[data-v-2a6449a4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.text-description[data-v-2a6449a4] {\n  color: #4a4a4a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 24px;\n}\n@media (max-width: 1024px) {\n.text-description[data-v-2a6449a4] {\n      font-size: 18px;\n}\n}\n.number-pillars[data-v-2a6449a4] {\n  color: #05316a;\n  font-size: 30px;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n}\n@media (max-width: 1024px) {\n.number-pillars[data-v-2a6449a4] {\n      font-size: 24px;\n}\n}\n.title-section-pillars[data-v-2a6449a4] {\n  color: #3bb4c1;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  line-height: 1.67;\n  margin-bottom: 30px;\n}\n@media (max-width: 1024px) {\n.title-section-pillars[data-v-2a6449a4] {\n      font-size: 18px;\n}\n}\n.content-text-pillars[data-v-2a6449a4] {\n  margin: 90px auto;\n  max-width: 455px;\n}\n@media (max-width: 1024px) {\n.content-text-pillars[data-v-2a6449a4] {\n      margin: 25px auto;\n}\n}\n@media (max-width: 1024px) {\n.icons-arrow[data-v-2a6449a4] {\n    width: 282px;\n}\n}\n.icon-logo-responsive[data-v-2a6449a4] {\n  margin-bottom: 60px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-pillars",attrs:{"column":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('router-link',{attrs:{"to":"/"}},[(_vm.windowSize.x < 1024)?_c('img',{staticClass:"icon-logo-responsive",attrs:{"src":"https://web-apprunn.s3-sa-east-1.amazonaws.com/logo-apprunn-responsive.svg","alt":""}}):_vm._e()])],1),_vm._v(" "),_c('v-flex',{staticClass:"grid-arrow",attrs:{"justify-center":""}},[_c('img',{staticClass:"icons-arrow",attrs:{"src":"https://japi-static.s3.amazonaws.com/japi-sales-error/arrows.png","alt":""}})]),_vm._v(" "),_c('v-layout',{staticClass:"content-text-pillars",attrs:{"column":""}},[_c('v-flex',{staticClass:"title-section-pillars",class:_vm.windowSize.x < 1024 ? 'text-xs-center' : 'text-xs-left'},[_vm._v("NUESTRO ÉXITO SE DEBE A "),_c('span',{staticClass:"number-pillars"},[_vm._v("3 PILARES")]),_vm._v(" IMPORTANTES EN NUESTRO DÍA A DÍA")]),_vm._v(" "),_c('v-flex',{staticClass:"text-description",class:_vm.windowSize.x < 1024 ? 'text-xs-center' : 'text-xs-left'},[_vm._v("Somos innovadores por excelencia, pero esta excelencia  se sostiene\n        en 3 pilares infalibles que nos permiten crear productos exitosos.")])],1),_vm._v(" "),_c('v-flex',{staticClass:"grid-arrow",attrs:{"justify-center":""}},[_c('img',{staticClass:"icons-arrow",attrs:{"src":"https://japi-static.s3.amazonaws.com/japi-sales-error/arrows.png","alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_pillars_vue__ = __webpack_require__(544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516093fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_pillars_vue__ = __webpack_require__(596);
function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-516093fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_pillars_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516093fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_pillars_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(595);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("624aaef8", content, true);

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".slider-pillars[data-v-516093fb]{background-size:cover;background-repeat:no-repeat;background-position:50%;width:100%}.number-pillars[data-v-516093fb]{color:#fff;font-family:Lato,sans-serif;font-weight:900;font-size:120px}@media (max-width:1024px){.number-pillars[data-v-516093fb]{font-size:72px}}.title-pillars[data-v-516093fb]{color:#fff;font-family:Lato,sans-serif;font-weight:900;font-size:36px;padding-left:17px;max-width:300px}@media (max-width:1024px){.title-pillars[data-v-516093fb]{font-size:22px;max-width:287px}}.content-slider[data-v-516093fb]{border:1px solid #fff;color:#fff;font-family:Lato,sans-serif;font-weight:400;font-size:24px;padding:62px 50px}@media (max-width:1024px){.content-slider[data-v-516093fb]{font-size:18px;font-family:Lato,sans-serif;font-weight:400;height:337px;padding:32px 15px}}.bar-pillars[data-v-516093fb]{background-color:#fff;height:109px;margin-left:17px;width:2px}@media (max-width:1024px){.bar-pillars[data-v-516093fb]{height:60px;margin-top:15px}}.text-fs[data-v-516093fb]{font-size:42px}@media (max-width:1024px){.text-fs[data-v-516093fb]{font-size:28px}}.mb-4[data-v-516093fb]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin-bottom:45px}.image[data-v-516093fb]{height:100vh;padding:185px 37px}@media (max-width:1024px){.image[data-v-516093fb]{height:640px;padding:87px 50px}}.slider-images[data-v-516093fb]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}", "", {"version":3,"sources":["/opt/build/repo/src/components/pillars/slider-pillars.vue"],"names":[],"mappings":"AACA,iCACE,sBAAuB,AACvB,4BAA6B,AAC7B,wBAA4B,AAC5B,UAAY,CACb,AACD,iCACE,WAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAiB,CAClB,AACD,0BACA,iCACM,cAAgB,CACrB,CACA,AACD,gCACE,WAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,0BACA,gCACM,eAAgB,AAChB,eAAiB,CACtB,CACA,AACD,iCACE,sBAAwB,AACxB,WAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACpB,AACD,0BACA,iCACM,eAAgB,AAChB,4BAAgC,AAChC,gBAAiB,AACjB,aAAc,AACd,iBAAmB,CACxB,CACA,AACD,8BACE,sBAA0B,AAC1B,aAAc,AACd,iBAAkB,AAClB,SAAW,CACZ,AACD,0BACA,8BACM,YAAa,AACb,eAAiB,CACtB,CACA,AACD,0BACE,cAAgB,CACjB,AACD,0BACA,0BACM,cAAgB,CACrB,CACA,AACD,uBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,kBAAoB,CACrB,AACD,wBACE,aAAc,AACd,kBAAoB,CACrB,AACD,0BACA,wBACM,aAAc,AACd,iBAAmB,CACxB,CACA,AACD,gCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC","file":"slider-pillars.vue","sourcesContent":["\n.slider-pillars[data-v-516093fb] {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 100%;\n}\n.number-pillars[data-v-516093fb] {\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 120px;\n}\n@media (max-width: 1024px) {\n.number-pillars[data-v-516093fb] {\n      font-size: 72px;\n}\n}\n.title-pillars[data-v-516093fb] {\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 36px;\n  padding-left: 17px;\n  max-width: 300px;\n}\n@media (max-width: 1024px) {\n.title-pillars[data-v-516093fb] {\n      font-size: 22px;\n      max-width: 287px;\n}\n}\n.content-slider[data-v-516093fb] {\n  border: 1px solid white;\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 24px;\n  padding: 62px 50px;\n}\n@media (max-width: 1024px) {\n.content-slider[data-v-516093fb] {\n      font-size: 18px;\n      font-family: 'Lato', sans-serif;\n      font-weight: 400;\n      height: 337px;\n      padding: 32px 15px;\n}\n}\n.bar-pillars[data-v-516093fb] {\n  background-color: #ffffff;\n  height: 109px;\n  margin-left: 17px;\n  width: 2px;\n}\n@media (max-width: 1024px) {\n.bar-pillars[data-v-516093fb] {\n      height: 60px;\n      margin-top: 15px;\n}\n}\n.text-fs[data-v-516093fb] {\n  font-size: 42px;\n}\n@media (max-width: 1024px) {\n.text-fs[data-v-516093fb] {\n      font-size: 28px;\n}\n}\n.mb-4[data-v-516093fb] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  margin-bottom: 45px;\n}\n.image[data-v-516093fb] {\n  height: 100vh;\n  padding: 185px 37px;\n}\n@media (max-width: 1024px) {\n.image[data-v-516093fb] {\n      height: 640px;\n      padding: 87px 50px;\n}\n}\n.slider-images[data-v-516093fb] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-pillars"},[_c('swiper',{attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.imgsPillars),function(item){return _c('swiper-slide',{key:item.id},[_c('div',{staticClass:"image",style:({ backgroundImage: ("url(" + (item.backgroundImage) + ")")})},[_c('div',{staticClass:"slider-images"},[_c('div',{staticClass:"mb-4"},[_c('p',{staticClass:"number-pillars"},[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('p',{staticClass:"bar-pillars"}),_vm._v(" "),_c('p',{staticClass:"title-pillars"},[_vm._v(_vm._s(item.title)+" "),_c('br'),_c('span',{staticClass:"text-fs"},[_vm._v(_vm._s(item.title42))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"content-slider"},[_c('p',[_vm._v(_vm._s(item.content))])])])])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"column":""}},[_c('div',{staticClass:"content-pillars"},[_c('div',{staticClass:"content-section"},[_c('section-pillars',{attrs:{"window-size":_vm.windowSize}})],1),_vm._v(" "),_c('div',{staticClass:"slider-pillars"},[_c('slider-pillars')],1)]),_vm._v(" "),_c('p',{staticClass:"background-gray"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.c9df331cceaa498b5861.js